import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
    {
      id: 1,
      icon: 'Shield',
      title: 'Enterprise Security',
      description: 'Bank-level encryption and data protection'
    },
    {
      id: 2,
      icon: 'Award',
      title: 'ISO 27001 Certified',
      description: 'International security standards compliance'
    },
    {
      id: 3,
      icon: 'Lock',
      title: 'SOC 2 Type II',
      description: 'Audited security and availability controls'
    },
    {
      id: 4,
      icon: 'CheckCircle2',
      title: '99.9% Uptime',
      description: 'Reliable and always available platform'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      {trustBadges?.map((badge) => (
        <div
          key={badge?.id}
          className="flex items-start gap-3 p-4 rounded-lg bg-card border border-border hover:border-primary/20 transition-smooth"
        >
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 flex-shrink-0">
            <Icon name={badge?.icon} size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-semibold text-foreground mb-1">
              {badge?.title}
            </h3>
            <p className="text-xs text-muted-foreground line-clamp-2">
              {badge?.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrustSignals;